var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn w-100",class:{'btn-info': _vm.checked},attrs:{"type":"button"},on:{"click":_vm.submit}},[_vm._v("Beobachten")])}
var staticRenderFns = []

export { render, staticRenderFns }